import { render, staticRenderFns } from "./_Section.vue?vue&type=template&id=2a9cd024&scoped=true&"
import script from "./_Section.vue?vue&type=script&lang=js&"
export * from "./_Section.vue?vue&type=script&lang=js&"
import style0 from "./_Section.vue?vue&type=style&index=0&id=2a9cd024&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9cd024",
  null
  
)

export default component.exports